import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import logger from './logger';
import { PARTICIPANTS_PANE_CLOSE, PARTICIPANTS_PANE_OPEN } from './actionTypes';
/**
 * Middleware which intercepts participants pane actions.
 *
 * @param {IStore} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(() => (next) => (action) => {
    switch (action.type) {
        case PARTICIPANTS_PANE_OPEN:
            if (typeof APP !== 'undefined') {
                try {
                    APP.API.notifyParticipantsPaneToggled(true);
                }
                catch (error) {
                    logger.error('Failed to notify participants pane opened', error);
                }
            }
            break;
        case PARTICIPANTS_PANE_CLOSE:
            if (typeof APP !== 'undefined') {
                try {
                    APP.API.notifyParticipantsPaneToggled(false);
                }
                catch (error) {
                    logger.error('Failed to notify participants pane closed', error);
                }
            }
            break;
    }
    return next(action);
});
